import { get, isEmpty, values } from 'lodash'
import humps from 'humps'
import PreOrdersItemViewModel from '../viewmodels/PreOrdersItemViewModel'
import ModifierGroupsViewModel from '../viewmodels/ModifierGroupsViewModel'

export default class DataMapper {

  static objectsById = (objects = []) => {
    return objects.reduce((result, object) => {
      return {
        ...result,
        [object.uuid || object.id || object.itemCategoryUuid]: object
      }
    }, {})
  }

  static preOrderMapper = (orders = []) => {
    const preOrders = humps.camelizeKeys(orders)
    let byId = DataMapper.objectsById(preOrders)

    values(byId).forEach(preOrder => {
      byId[preOrder.uuid] = {
        ...preOrder,
        isTab: true,
        isSyncing: false,
        isOnline: true,
        isPreOrder: `${preOrder.serviceType}`.toLowerCase() === 'preorder',
        syncedAt: preOrder.updatedAt,
        orderState: preOrder.state === 'closed' ? 'closed' : 'open',
        submittedAt: preOrder.createdAt,
        itemModels: preOrder.lineItems.map(lineItem => PreOrdersItemViewModel(lineItem)),
        createOrderParams: {},
        amountInCents: parseInt(preOrder.total.replace('.', '')),
        modifiedAt: preOrder.updatedAt,
        revenueCenterUuid: preOrder.standUuid,
        orderNumber: get(preOrder, 'orderSubmissionResult.orderNumber', 'unknown'),
        // TODO: Implement payment information
      }
    })

    return byId
  }

  static itemModifiersMapper = (item) => {
    if (isEmpty(item.modifierGroups)) return

    let result = ModifierGroupsViewModel(item.modifierGroups)
    return result
  }
}
